<template>
  <div class="chart-container">
    <canvas ref="canvas"></canvas>
  </div>
</template>  

<script>
import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  mounted() {
    const generateRandomData = () => {
      return Array.from({ length: 4 }, () => Math.floor(Math.random() * 100));
    };

    this.renderChart({
      labels: ['Commission', 'Discommission', 'Aggregation', 'Disaggregation'],
      datasets: [
        {
          backgroundColor: [
            '#a07fc6',
            '#63c2de',
            '#ffc107',
            '#f86c6b'
          ],
          data: generateRandomData()
        }
      ]
    }, {responsive: true, maintainAspectRatio: true})
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 100%; /* 고정된 높이를 제거 */
  position: relative;
  padding-bottom: 50%; /* 2:1 비율을 유지하기 위한 패딩 */
}
canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
}
</style>
